<template>
    <div class="cabinet-profile">
        <form class="cabinet-profile__block"
              :action="result?.form?.action"
              :method="result?.form?.method"
              :name="result?.form?.name"
              :enctype="result?.form?.enctype"
              id="cabinet-profile__main"
        >
            <div class="error" v-if="result?.errors" v-html="result?.errors"></div>
            <div v-for="field in result?.form?.fields">
                <def-input
                           v-if="field.type === 'text' && field.name !== 'EMAIL' && field.name !== 'PHONE_NUMBER'"
                           class="cabinet-profile__input"
                           :value="field.value"
                           :name="field.name"
                           :label="field.title"
                           :id="field.title"
                           :required="field.name === 'LOGIN'"
                />
            </div>
            <div  v-for="field in result?.form?.fields">
                <div class="cabinet-profile__phone"
                     v-if="field.name === 'PHONE_NUMBER'"
                >
                    <span class="cabinet-profile__phone-title">{{field.title}}</span>
                    <input
                        type="text"
                        :value="field.value"
                        :name="field.name"
                        :form="field.name === 'PHONE_NUMBER' ? 'changePhone' : 'cabinet-profile__main'"
                        :disabled="field.name === 'PHONE_NUMBER' && disable"
                    />
                    <span v-if="field.name === 'PHONE_NUMBER' && disable"
                          class="cabinet-profile__change"
                          @click="handlerChangePhone(result.changePhoneFields)"
                    >
                    {{ result.changePhoneFields.messages.edit_btn }}</span>
                </div>
            </div>

            <div v-for="field in result?.form?.fields">
                <def-email
                           class="cabinet-profile__input"
                           v-if="field.userType === 'email'"
                           :value="field.value"
                           :name="field.name"
                           :label="field.title"
                           :id="field.title"
                />

                <date-picker    v-else-if="field.type === 'date'" :result="field" />
                <input          v-else-if="field.type === 'hidden'" type="hidden" :value="field.value" :name="field.name">
                <button         v-else-if="field.type === 'submit'"
                                :name="field.name"
                                :value="field.value"
                                class="def-button"
                                type="submit">
                    {{ field.placeholder }}
                </button>

                <div v-else-if="field.type == 'sots'&&field.value.length>0" class="social-block">
                    <a v-for="item in field.value"
                       :href="item.link"
                       class="social-block__item"

                    >
                        <svg v-if="item.icon === 'facebook'" class="social-block__facebook">
                            <use xlink:href="#svg-facebook-new"></use>
                        </svg>
                        <svg v-else-if="item.icon === 'instagram'">
                            <use xlink:href="#svg-instagram"></use>
                        </svg>
                        <svg v-else-if="item.icon === 'google'">
                            <use xlink:href="#svg-google-new"></use>
                        </svg>
                    </a>
                </div>
            </div>

        </form>
        <PersonalSubscribes />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'personal',
    data(){
        return{
            disable: true,
        }
    },
    computed: {
        ...mapState({
            result: ({ personalCabinet }) => personalCabinet?.data,
            personal: ({ personal }) => personal?.data,
        }),
    },
    methods:{
        handlerChangePhone(field) {
            this.$DefModal.show({
                name: 'change-phone',
                width: '368px',
                props: {
                    result: field,
                }
            });
        }
    },
    mounted(){
        //Делал Бек
        let name = "";
        let sname = "";
        this.result.form.fields.forEach(el => {
            if(el.name=="NAME") {
                name = el.value;
            }
            if(el.name=="LAST_NAME") {
                sname = el.value;
            }
        })

        // this.personal.authInfo.user_name = name+" "+sname;



        this.$store.commit('personal/updateData', {name: 'authInfo', data: {...this.personal.authInfo,user_name:name+" "+(sname || '')}})
        this.$store.commit('personal/setData', this.personal);
    }
}
</script>

<style lang="scss" scoped>
    .cabinet-profile{
        font-family: 'TT COMMONS', sans-serif;

        &__block{
            display: flex;
            flex-direction: column;
           @include point-lg{
               max-width: 400px;
           }
        }
        &__input{
            margin-bottom: 8px;
            input{
                font-size: 16px;
                font-weight: 500;
            }

            &.disable{
                background: #F3F4F5;
            }

            button{
                background: none;
                display: inherit;
                right: 15px;
                position: absolute;
                top: 23px;
                text-transform: uppercase;
                font-weight: 500;
                border-bottom: 1px dashed #191918;
                letter-spacing: 0.1em;
            }
        }

        &__date{
            margin: 24px 0;
        }
        &__change{
            position: absolute;
            top: 50%;
            right: 16px;
            transform: translateY(-50%);
            font-weight: 500;
            font-size: rem(12);
            line-height: 115%;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            color: #191918;
            cursor: pointer;
            text-decoration: underline;
            text-decoration-style: dashed;
            text-decoration-color: #191918;
            text-underline-position: under;
        }
        .def-title-5{
            font-size: rem(18);
            line-height: 120%;
            color: #191918;
        }
        .def-button{
            align-self: flex-start;
            font-size: rem(14);
            font-weight: 500;
            letter-spacing: 0.08em;
            text-transform: uppercase;
        }
        .social-block{
            display: flex;
            align-items: center;
            margin-top: 20px;
            &__item{
                display: flex;
                align-items: center;
                &:not(:last-child) {
                    margin-right: 24px;
                }
                svg{
                    width: 24px;
                    height: 24px;
                    /*fill: var(--border-colour-primary);*/
                }
            }
        }
        &__phone{
            margin-bottom: 8px;
            position: relative;
            input{
                width: 100%;
                padding: 0 16px;
                border: 1px solid #E5E5E5;
                font-size: rem(14);
                height: 56px;
            }
        }
        &__phone-title{
            pointer-events: none;
            position: absolute;
            z-index: 1;
            padding-left: 16px;
            left: 0;
            line-height: 1em;
            transition: .2s linear transform, .2s linear font-size, .2s linear top;
            cursor: text;
            font-size: 12px;
            top: 12px;
            transform: translateY(-50%);
            color: #757575;
            white-space: nowrap;
            overflow: hidden;
            display: block;
            max-width: calc(100% - 16px);
            text-overflow: ellipsis;
            text-transform: uppercase;
        }
    }
    .error {
        color: #f00;
        margin-bottom: 10px;
    }
</style>